/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountingRouteImport } from './routes/accounting'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BulkImportRouteImport } from './routes/bulk-import'
import { Route as TerminalsRouteImport } from './routes/terminals'
import { Route as AccountingTypeRouteImport } from './routes/accounting.$type'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminClientsRouteImport } from './routes/admin.clients'
import { Route as AdminLkqFuelRateRouteImport } from './routes/admin.lkq-fuel-rate'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminVendorsRouteImport } from './routes/admin.vendors'
import { Route as BulkImportIndexRouteImport } from './routes/bulk-import.index'
import { Route as BulkImportImportsRouteImport } from './routes/bulk-import.imports'
import { Route as BulkImportTemplatesRouteImport } from './routes/bulk-import.templates'
import { Route as JobsStatusRouteImport } from './routes/jobs.$status'
import { Route as OrderCreateRouteImport } from './routes/order.create'
import { Route as OrdersOrderGuidRouteImport } from './routes/orders.$orderGuid'
import { Route as ReportsReportIdRouteImport } from './routes/reports.$reportId'
import { Route as TerminalsIndexRouteImport } from './routes/terminals.index'
import { Route as TerminalsAssignmentsRouteImport } from './routes/terminals.assignments'
import { Route as TerminalsLanesRouteImport } from './routes/terminals.lanes'
import { Route as TerminalsLocationsRouteImport } from './routes/terminals.locations'
import { Route as AccountingTypeIndexRouteImport } from './routes/accounting.$type.index'
import { Route as AccountingTypeGuidRouteImport } from './routes/accounting.$type.$guid'
import { Route as AccountingReportsReportIdRouteImport } from './routes/accounting.reports.$reportId'
import { Route as AdminCargoTelConfigsRouteImport } from './routes/admin.cargo-tel.configs'
import { Route as AdminClientsIndexRouteImport } from './routes/admin.clients.index'
import { Route as AdminClientsClientGuidRouteImport } from './routes/admin.clients.$clientGuid'
import { Route as AdminIntegrationsAppsRouteImport } from './routes/admin.integrations.apps'
import { Route as AdminIntegrationsCompaniesRouteImport } from './routes/admin.integrations.companies'
import { Route as AdminIntegrationsConfigsRouteImport } from './routes/admin.integrations.configs'
import { Route as AdminInvoicesSyncVinAmountsRouteImport } from './routes/admin.invoices.sync-vin-amounts'
import { Route as AdminLoadboardsDuplicatesRouteImport } from './routes/admin.loadboards.duplicates'
import { Route as AdminLoadboardsUnsyncedRouteImport } from './routes/admin.loadboards.unsynced'
import { Route as AdminOrderCaseLabelsRouteImport } from './routes/admin.order.case-labels'
import { Route as AdminOrderListRouteImport } from './routes/admin.order.list'
import { Route as AdminUsersIndexRouteImport } from './routes/admin.users.index'
import { Route as AdminUsersUserGuidRouteImport } from './routes/admin.users.$userGuid'
import { Route as AdminVendorsIndexRouteImport } from './routes/admin.vendors.index'
import { Route as AdminVendorsVendorGuidRouteImport } from './routes/admin.vendors.$vendorGuid'
import { Route as BulkImportImportsIndexRouteImport } from './routes/bulk-import.imports.index'
import { Route as BulkImportImportsImportGuidRouteImport } from './routes/bulk-import.imports.$importGuid'
import { Route as BulkImportImportsCreateRouteImport } from './routes/bulk-import.imports.create'
import { Route as BulkImportTemplatesIndexRouteImport } from './routes/bulk-import.templates.index'
import { Route as BulkImportTemplatesTemplateIdRouteImport } from './routes/bulk-import.templates.$templateId'
import { Route as BulkImportTemplatesCreateRouteImport } from './routes/bulk-import.templates.create'
import { Route as OrdersOrderGuidIndexRouteImport } from './routes/orders.$orderGuid.index'
import { Route as OrdersOrderGuidAttachmentsRouteImport } from './routes/orders.$orderGuid.attachments'
import { Route as OrdersOrderGuidLedgerRouteImport } from './routes/orders.$orderGuid.ledger'
import { Route as TerminalsAssignmentsIdRouteImport } from './routes/terminals.assignments.$id'
import { Route as TerminalsAssignmentsCreateRouteImport } from './routes/terminals.assignments.create'
import { Route as TerminalsLanesIdRouteImport } from './routes/terminals.lanes.$id'
import { Route as TerminalsLanesCreateRouteImport } from './routes/terminals.lanes.create'
import { Route as TerminalsLocationsTerminalIdRouteImport } from './routes/terminals.locations.$terminalId'
import { Route as TerminalsLocationsCreateRouteImport } from './routes/terminals.locations.create'
import { Route as AdminClientsClientGuidIndexRouteImport } from './routes/admin.clients.$clientGuid.index'
import { Route as AdminClientsClientGuidContactsRouteImport } from './routes/admin.clients.$clientGuid.contacts'
import { Route as AdminOrderReportsReportIdRouteImport } from './routes/admin.order.reports.$reportId'
import { Route as AdminVendorsVendorGuidIndexRouteImport } from './routes/admin.vendors.$vendorGuid.index'
import { Route as AdminVendorsVendorGuidContactsRouteImport } from './routes/admin.vendors.$vendorGuid.contacts'
import { Route as OrdersOrderGuidJobsJobGuidRouteImport } from './routes/orders.$orderGuid_.jobs.$jobGuid'
import { Route as OrdersOrderGuidJobsCreateRouteImport } from './routes/orders.$orderGuid_.jobs.create'
import { Route as TerminalsLocationsTerminalIdContactsRouteImport } from './routes/terminals.locations.$terminalId_.contacts'
import { Route as TerminalsLocationsTerminalIdMergeRouteImport } from './routes/terminals.locations.$terminalId_.merge'
import { Route as AdminClientsClientGuidContactsIndexRouteImport } from './routes/admin.clients.$clientGuid.contacts.index'
import { Route as AdminClientsClientGuidContactsContactGuidRouteImport } from './routes/admin.clients.$clientGuid.contacts.$contactGuid'
import { Route as AdminVendorsVendorGuidContactsIndexRouteImport } from './routes/admin.vendors.$vendorGuid.contacts.index'
import { Route as AdminVendorsVendorGuidContactsContactGuidRouteImport } from './routes/admin.vendors.$vendorGuid.contacts.$contactGuid'
import { Route as OrdersOrderGuidJobsJobGuidIndexRouteImport } from './routes/orders.$orderGuid_.jobs.$jobGuid.index'
import { Route as OrdersOrderGuidJobsJobGuidActivityRouteImport } from './routes/orders.$orderGuid_.jobs.$jobGuid.activity'
import { Route as OrdersOrderGuidJobsJobGuidAttachmentsRouteImport } from './routes/orders.$orderGuid_.jobs.$jobGuid.attachments'
import { Route as OrdersOrderGuidJobsJobGuidLedgerRouteImport } from './routes/orders.$orderGuid_.jobs.$jobGuid.ledger'
import { Route as OrdersOrderGuidJobsJobGuidRequestsRouteImport } from './routes/orders.$orderGuid_.jobs.$jobGuid.requests'
import { Route as TerminalsLocationsTerminalIdContactsContactIdRouteImport } from './routes/terminals.locations.$terminalId_.contacts.$contactId'
import { Route as TerminalsLocationsTerminalIdContactsCreateRouteImport } from './routes/terminals.locations.$terminalId_.contacts.create'
import { Route as TerminalsLocationsTerminalIdContactsContactIdMergeRouteImport } from './routes/terminals.locations.$terminalId_.contacts.$contactId_.merge'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingRoute = AccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BulkImportRoute = BulkImportRouteImport.update({
  id: '/bulk-import',
  path: '/bulk-import',
  getParentRoute: () => rootRouteImport,
} as any)
const TerminalsRoute = TerminalsRouteImport.update({
  id: '/terminals',
  path: '/terminals',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingTypeRoute = AccountingTypeRouteImport.update({
  id: '/$type',
  path: '/$type',
  getParentRoute: () => AccountingRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClientsRoute = AdminClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLkqFuelRateRoute = AdminLkqFuelRateRouteImport.update({
  id: '/lkq-fuel-rate',
  path: '/lkq-fuel-rate',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVendorsRoute = AdminVendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => AdminRoute,
} as any)
const BulkImportIndexRoute = BulkImportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BulkImportRoute,
} as any)
const BulkImportImportsRoute = BulkImportImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => BulkImportRoute,
} as any)
const BulkImportTemplatesRoute = BulkImportTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => BulkImportRoute,
} as any)
const JobsStatusRoute = JobsStatusRouteImport.update({
  id: '/jobs/$status',
  path: '/jobs/$status',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderCreateRoute = OrderCreateRouteImport.update({
  id: '/order/create',
  path: '/order/create',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderGuidRoute = OrdersOrderGuidRouteImport.update({
  id: '/orders/$orderGuid',
  path: '/orders/$orderGuid',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsReportIdRoute = ReportsReportIdRouteImport.update({
  id: '/reports/$reportId',
  path: '/reports/$reportId',
  getParentRoute: () => rootRouteImport,
} as any)
const TerminalsIndexRoute = TerminalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TerminalsRoute,
} as any)
const TerminalsAssignmentsRoute = TerminalsAssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => TerminalsRoute,
} as any)
const TerminalsLanesRoute = TerminalsLanesRouteImport.update({
  id: '/lanes',
  path: '/lanes',
  getParentRoute: () => TerminalsRoute,
} as any)
const TerminalsLocationsRoute = TerminalsLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => TerminalsRoute,
} as any)
const AccountingTypeIndexRoute = AccountingTypeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountingTypeRoute,
} as any)
const AccountingTypeGuidRoute = AccountingTypeGuidRouteImport.update({
  id: '/$guid',
  path: '/$guid',
  getParentRoute: () => AccountingTypeRoute,
} as any)
const AccountingReportsReportIdRoute =
  AccountingReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AccountingRoute,
  } as any)
const AdminCargoTelConfigsRoute = AdminCargoTelConfigsRouteImport.update({
  id: '/cargo-tel/configs',
  path: '/cargo-tel/configs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClientsIndexRoute = AdminClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminClientsRoute,
} as any)
const AdminClientsClientGuidRoute = AdminClientsClientGuidRouteImport.update({
  id: '/$clientGuid',
  path: '/$clientGuid',
  getParentRoute: () => AdminClientsRoute,
} as any)
const AdminIntegrationsAppsRoute = AdminIntegrationsAppsRouteImport.update({
  id: '/integrations/apps',
  path: '/integrations/apps',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegrationsCompaniesRoute =
  AdminIntegrationsCompaniesRouteImport.update({
    id: '/integrations/companies',
    path: '/integrations/companies',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminIntegrationsConfigsRoute =
  AdminIntegrationsConfigsRouteImport.update({
    id: '/integrations/configs',
    path: '/integrations/configs',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminInvoicesSyncVinAmountsRoute =
  AdminInvoicesSyncVinAmountsRouteImport.update({
    id: '/invoices/sync-vin-amounts',
    path: '/invoices/sync-vin-amounts',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminLoadboardsDuplicatesRoute =
  AdminLoadboardsDuplicatesRouteImport.update({
    id: '/loadboards/duplicates',
    path: '/loadboards/duplicates',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminLoadboardsUnsyncedRoute = AdminLoadboardsUnsyncedRouteImport.update({
  id: '/loadboards/unsynced',
  path: '/loadboards/unsynced',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrderCaseLabelsRoute = AdminOrderCaseLabelsRouteImport.update({
  id: '/order/case-labels',
  path: '/order/case-labels',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrderListRoute = AdminOrderListRouteImport.update({
  id: '/order/list',
  path: '/order/list',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminUsersUserGuidRoute = AdminUsersUserGuidRouteImport.update({
  id: '/$userGuid',
  path: '/$userGuid',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminVendorsIndexRoute = AdminVendorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminVendorsRoute,
} as any)
const AdminVendorsVendorGuidRoute = AdminVendorsVendorGuidRouteImport.update({
  id: '/$vendorGuid',
  path: '/$vendorGuid',
  getParentRoute: () => AdminVendorsRoute,
} as any)
const BulkImportImportsIndexRoute = BulkImportImportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BulkImportImportsRoute,
} as any)
const BulkImportImportsImportGuidRoute =
  BulkImportImportsImportGuidRouteImport.update({
    id: '/$importGuid',
    path: '/$importGuid',
    getParentRoute: () => BulkImportImportsRoute,
  } as any)
const BulkImportImportsCreateRoute = BulkImportImportsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => BulkImportImportsRoute,
} as any)
const BulkImportTemplatesIndexRoute =
  BulkImportTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BulkImportTemplatesRoute,
  } as any)
const BulkImportTemplatesTemplateIdRoute =
  BulkImportTemplatesTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => BulkImportTemplatesRoute,
  } as any)
const BulkImportTemplatesCreateRoute =
  BulkImportTemplatesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BulkImportTemplatesRoute,
  } as any)
const OrdersOrderGuidIndexRoute = OrdersOrderGuidIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrdersOrderGuidRoute,
} as any)
const OrdersOrderGuidAttachmentsRoute =
  OrdersOrderGuidAttachmentsRouteImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => OrdersOrderGuidRoute,
  } as any)
const OrdersOrderGuidLedgerRoute = OrdersOrderGuidLedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => OrdersOrderGuidRoute,
} as any)
const TerminalsAssignmentsIdRoute = TerminalsAssignmentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TerminalsAssignmentsRoute,
} as any)
const TerminalsAssignmentsCreateRoute =
  TerminalsAssignmentsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => TerminalsAssignmentsRoute,
  } as any)
const TerminalsLanesIdRoute = TerminalsLanesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TerminalsLanesRoute,
} as any)
const TerminalsLanesCreateRoute = TerminalsLanesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => TerminalsLanesRoute,
} as any)
const TerminalsLocationsTerminalIdRoute =
  TerminalsLocationsTerminalIdRouteImport.update({
    id: '/$terminalId',
    path: '/$terminalId',
    getParentRoute: () => TerminalsLocationsRoute,
  } as any)
const TerminalsLocationsCreateRoute =
  TerminalsLocationsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => TerminalsLocationsRoute,
  } as any)
const AdminClientsClientGuidIndexRoute =
  AdminClientsClientGuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminClientsClientGuidRoute,
  } as any)
const AdminClientsClientGuidContactsRoute =
  AdminClientsClientGuidContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AdminClientsClientGuidRoute,
  } as any)
const AdminOrderReportsReportIdRoute =
  AdminOrderReportsReportIdRouteImport.update({
    id: '/order/reports/$reportId',
    path: '/order/reports/$reportId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminVendorsVendorGuidIndexRoute =
  AdminVendorsVendorGuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminVendorsVendorGuidRoute,
  } as any)
const AdminVendorsVendorGuidContactsRoute =
  AdminVendorsVendorGuidContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AdminVendorsVendorGuidRoute,
  } as any)
const OrdersOrderGuidJobsJobGuidRoute =
  OrdersOrderGuidJobsJobGuidRouteImport.update({
    id: '/orders/$orderGuid_/jobs/$jobGuid',
    path: '/orders/$orderGuid/jobs/$jobGuid',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrdersOrderGuidJobsCreateRoute =
  OrdersOrderGuidJobsCreateRouteImport.update({
    id: '/orders/$orderGuid_/jobs/create',
    path: '/orders/$orderGuid/jobs/create',
    getParentRoute: () => rootRouteImport,
  } as any)
const TerminalsLocationsTerminalIdContactsRoute =
  TerminalsLocationsTerminalIdContactsRouteImport.update({
    id: '/$terminalId_/contacts',
    path: '/$terminalId/contacts',
    getParentRoute: () => TerminalsLocationsRoute,
  } as any)
const TerminalsLocationsTerminalIdMergeRoute =
  TerminalsLocationsTerminalIdMergeRouteImport.update({
    id: '/$terminalId_/merge',
    path: '/$terminalId/merge',
    getParentRoute: () => TerminalsLocationsRoute,
  } as any)
const AdminClientsClientGuidContactsIndexRoute =
  AdminClientsClientGuidContactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminClientsClientGuidContactsRoute,
  } as any)
const AdminClientsClientGuidContactsContactGuidRoute =
  AdminClientsClientGuidContactsContactGuidRouteImport.update({
    id: '/$contactGuid',
    path: '/$contactGuid',
    getParentRoute: () => AdminClientsClientGuidContactsRoute,
  } as any)
const AdminVendorsVendorGuidContactsIndexRoute =
  AdminVendorsVendorGuidContactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminVendorsVendorGuidContactsRoute,
  } as any)
const AdminVendorsVendorGuidContactsContactGuidRoute =
  AdminVendorsVendorGuidContactsContactGuidRouteImport.update({
    id: '/$contactGuid',
    path: '/$contactGuid',
    getParentRoute: () => AdminVendorsVendorGuidContactsRoute,
  } as any)
const OrdersOrderGuidJobsJobGuidIndexRoute =
  OrdersOrderGuidJobsJobGuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrdersOrderGuidJobsJobGuidRoute,
  } as any)
const OrdersOrderGuidJobsJobGuidActivityRoute =
  OrdersOrderGuidJobsJobGuidActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => OrdersOrderGuidJobsJobGuidRoute,
  } as any)
const OrdersOrderGuidJobsJobGuidAttachmentsRoute =
  OrdersOrderGuidJobsJobGuidAttachmentsRouteImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => OrdersOrderGuidJobsJobGuidRoute,
  } as any)
const OrdersOrderGuidJobsJobGuidLedgerRoute =
  OrdersOrderGuidJobsJobGuidLedgerRouteImport.update({
    id: '/ledger',
    path: '/ledger',
    getParentRoute: () => OrdersOrderGuidJobsJobGuidRoute,
  } as any)
const OrdersOrderGuidJobsJobGuidRequestsRoute =
  OrdersOrderGuidJobsJobGuidRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => OrdersOrderGuidJobsJobGuidRoute,
  } as any)
const TerminalsLocationsTerminalIdContactsContactIdRoute =
  TerminalsLocationsTerminalIdContactsContactIdRouteImport.update({
    id: '/$contactId',
    path: '/$contactId',
    getParentRoute: () => TerminalsLocationsTerminalIdContactsRoute,
  } as any)
const TerminalsLocationsTerminalIdContactsCreateRoute =
  TerminalsLocationsTerminalIdContactsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => TerminalsLocationsTerminalIdContactsRoute,
  } as any)
const TerminalsLocationsTerminalIdContactsContactIdMergeRoute =
  TerminalsLocationsTerminalIdContactsContactIdMergeRouteImport.update({
    id: '/$contactId_/merge',
    path: '/$contactId/merge',
    getParentRoute: () => TerminalsLocationsTerminalIdContactsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/bulk-import': typeof BulkImportRouteWithChildren
  '/terminals': typeof TerminalsRouteWithChildren
  '/accounting/$type': typeof AccountingTypeRouteWithChildren
  '/admin/clients': typeof AdminClientsRouteWithChildren
  '/admin/lkq-fuel-rate': typeof AdminLkqFuelRateRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/vendors': typeof AdminVendorsRouteWithChildren
  '/bulk-import/imports': typeof BulkImportImportsRouteWithChildren
  '/bulk-import/templates': typeof BulkImportTemplatesRouteWithChildren
  '/jobs/$status': typeof JobsStatusRoute
  '/order/create': typeof OrderCreateRoute
  '/orders/$orderGuid': typeof OrdersOrderGuidRouteWithChildren
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/terminals/assignments': typeof TerminalsAssignmentsRouteWithChildren
  '/terminals/lanes': typeof TerminalsLanesRouteWithChildren
  '/terminals/locations': typeof TerminalsLocationsRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/bulk-import/': typeof BulkImportIndexRoute
  '/terminals/': typeof TerminalsIndexRoute
  '/accounting/$type/$guid': typeof AccountingTypeGuidRoute
  '/accounting/reports/$reportId': typeof AccountingReportsReportIdRoute
  '/admin/cargo-tel/configs': typeof AdminCargoTelConfigsRoute
  '/admin/clients/$clientGuid': typeof AdminClientsClientGuidRouteWithChildren
  '/admin/integrations/apps': typeof AdminIntegrationsAppsRoute
  '/admin/integrations/companies': typeof AdminIntegrationsCompaniesRoute
  '/admin/integrations/configs': typeof AdminIntegrationsConfigsRoute
  '/admin/invoices/sync-vin-amounts': typeof AdminInvoicesSyncVinAmountsRoute
  '/admin/loadboards/duplicates': typeof AdminLoadboardsDuplicatesRoute
  '/admin/loadboards/unsynced': typeof AdminLoadboardsUnsyncedRoute
  '/admin/order/case-labels': typeof AdminOrderCaseLabelsRoute
  '/admin/order/list': typeof AdminOrderListRoute
  '/admin/users/$userGuid': typeof AdminUsersUserGuidRoute
  '/admin/vendors/$vendorGuid': typeof AdminVendorsVendorGuidRouteWithChildren
  '/bulk-import/imports/$importGuid': typeof BulkImportImportsImportGuidRoute
  '/bulk-import/imports/create': typeof BulkImportImportsCreateRoute
  '/bulk-import/templates/$templateId': typeof BulkImportTemplatesTemplateIdRoute
  '/bulk-import/templates/create': typeof BulkImportTemplatesCreateRoute
  '/orders/$orderGuid/attachments': typeof OrdersOrderGuidAttachmentsRoute
  '/orders/$orderGuid/ledger': typeof OrdersOrderGuidLedgerRoute
  '/terminals/assignments/$id': typeof TerminalsAssignmentsIdRoute
  '/terminals/assignments/create': typeof TerminalsAssignmentsCreateRoute
  '/terminals/lanes/$id': typeof TerminalsLanesIdRoute
  '/terminals/lanes/create': typeof TerminalsLanesCreateRoute
  '/terminals/locations/$terminalId': typeof TerminalsLocationsTerminalIdRoute
  '/terminals/locations/create': typeof TerminalsLocationsCreateRoute
  '/accounting/$type/': typeof AccountingTypeIndexRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/vendors/': typeof AdminVendorsIndexRoute
  '/bulk-import/imports/': typeof BulkImportImportsIndexRoute
  '/bulk-import/templates/': typeof BulkImportTemplatesIndexRoute
  '/orders/$orderGuid/': typeof OrdersOrderGuidIndexRoute
  '/admin/clients/$clientGuid/contacts': typeof AdminClientsClientGuidContactsRouteWithChildren
  '/admin/order/reports/$reportId': typeof AdminOrderReportsReportIdRoute
  '/admin/vendors/$vendorGuid/contacts': typeof AdminVendorsVendorGuidContactsRouteWithChildren
  '/orders/$orderGuid/jobs/$jobGuid': typeof OrdersOrderGuidJobsJobGuidRouteWithChildren
  '/orders/$orderGuid/jobs/create': typeof OrdersOrderGuidJobsCreateRoute
  '/terminals/locations/$terminalId/contacts': typeof TerminalsLocationsTerminalIdContactsRouteWithChildren
  '/terminals/locations/$terminalId/merge': typeof TerminalsLocationsTerminalIdMergeRoute
  '/admin/clients/$clientGuid/': typeof AdminClientsClientGuidIndexRoute
  '/admin/vendors/$vendorGuid/': typeof AdminVendorsVendorGuidIndexRoute
  '/admin/clients/$clientGuid/contacts/$contactGuid': typeof AdminClientsClientGuidContactsContactGuidRoute
  '/admin/vendors/$vendorGuid/contacts/$contactGuid': typeof AdminVendorsVendorGuidContactsContactGuidRoute
  '/orders/$orderGuid/jobs/$jobGuid/activity': typeof OrdersOrderGuidJobsJobGuidActivityRoute
  '/orders/$orderGuid/jobs/$jobGuid/attachments': typeof OrdersOrderGuidJobsJobGuidAttachmentsRoute
  '/orders/$orderGuid/jobs/$jobGuid/ledger': typeof OrdersOrderGuidJobsJobGuidLedgerRoute
  '/orders/$orderGuid/jobs/$jobGuid/requests': typeof OrdersOrderGuidJobsJobGuidRequestsRoute
  '/terminals/locations/$terminalId/contacts/$contactId': typeof TerminalsLocationsTerminalIdContactsContactIdRoute
  '/terminals/locations/$terminalId/contacts/create': typeof TerminalsLocationsTerminalIdContactsCreateRoute
  '/admin/clients/$clientGuid/contacts/': typeof AdminClientsClientGuidContactsIndexRoute
  '/admin/vendors/$vendorGuid/contacts/': typeof AdminVendorsVendorGuidContactsIndexRoute
  '/orders/$orderGuid/jobs/$jobGuid/': typeof OrdersOrderGuidJobsJobGuidIndexRoute
  '/terminals/locations/$terminalId/contacts/$contactId/merge': typeof TerminalsLocationsTerminalIdContactsContactIdMergeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRouteWithChildren
  '/admin/lkq-fuel-rate': typeof AdminLkqFuelRateRoute
  '/jobs/$status': typeof JobsStatusRoute
  '/order/create': typeof OrderCreateRoute
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/terminals/assignments': typeof TerminalsAssignmentsRouteWithChildren
  '/terminals/lanes': typeof TerminalsLanesRouteWithChildren
  '/terminals/locations': typeof TerminalsLocationsRouteWithChildren
  '/admin': typeof AdminIndexRoute
  '/bulk-import': typeof BulkImportIndexRoute
  '/terminals': typeof TerminalsIndexRoute
  '/accounting/$type/$guid': typeof AccountingTypeGuidRoute
  '/accounting/reports/$reportId': typeof AccountingReportsReportIdRoute
  '/admin/cargo-tel/configs': typeof AdminCargoTelConfigsRoute
  '/admin/integrations/apps': typeof AdminIntegrationsAppsRoute
  '/admin/integrations/companies': typeof AdminIntegrationsCompaniesRoute
  '/admin/integrations/configs': typeof AdminIntegrationsConfigsRoute
  '/admin/invoices/sync-vin-amounts': typeof AdminInvoicesSyncVinAmountsRoute
  '/admin/loadboards/duplicates': typeof AdminLoadboardsDuplicatesRoute
  '/admin/loadboards/unsynced': typeof AdminLoadboardsUnsyncedRoute
  '/admin/order/case-labels': typeof AdminOrderCaseLabelsRoute
  '/admin/order/list': typeof AdminOrderListRoute
  '/admin/users/$userGuid': typeof AdminUsersUserGuidRoute
  '/bulk-import/imports/$importGuid': typeof BulkImportImportsImportGuidRoute
  '/bulk-import/imports/create': typeof BulkImportImportsCreateRoute
  '/bulk-import/templates/$templateId': typeof BulkImportTemplatesTemplateIdRoute
  '/bulk-import/templates/create': typeof BulkImportTemplatesCreateRoute
  '/orders/$orderGuid/attachments': typeof OrdersOrderGuidAttachmentsRoute
  '/orders/$orderGuid/ledger': typeof OrdersOrderGuidLedgerRoute
  '/terminals/assignments/$id': typeof TerminalsAssignmentsIdRoute
  '/terminals/assignments/create': typeof TerminalsAssignmentsCreateRoute
  '/terminals/lanes/$id': typeof TerminalsLanesIdRoute
  '/terminals/lanes/create': typeof TerminalsLanesCreateRoute
  '/terminals/locations/$terminalId': typeof TerminalsLocationsTerminalIdRoute
  '/terminals/locations/create': typeof TerminalsLocationsCreateRoute
  '/accounting/$type': typeof AccountingTypeIndexRoute
  '/admin/clients': typeof AdminClientsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/vendors': typeof AdminVendorsIndexRoute
  '/bulk-import/imports': typeof BulkImportImportsIndexRoute
  '/bulk-import/templates': typeof BulkImportTemplatesIndexRoute
  '/orders/$orderGuid': typeof OrdersOrderGuidIndexRoute
  '/admin/order/reports/$reportId': typeof AdminOrderReportsReportIdRoute
  '/orders/$orderGuid/jobs/create': typeof OrdersOrderGuidJobsCreateRoute
  '/terminals/locations/$terminalId/contacts': typeof TerminalsLocationsTerminalIdContactsRouteWithChildren
  '/terminals/locations/$terminalId/merge': typeof TerminalsLocationsTerminalIdMergeRoute
  '/admin/clients/$clientGuid': typeof AdminClientsClientGuidIndexRoute
  '/admin/vendors/$vendorGuid': typeof AdminVendorsVendorGuidIndexRoute
  '/admin/clients/$clientGuid/contacts/$contactGuid': typeof AdminClientsClientGuidContactsContactGuidRoute
  '/admin/vendors/$vendorGuid/contacts/$contactGuid': typeof AdminVendorsVendorGuidContactsContactGuidRoute
  '/orders/$orderGuid/jobs/$jobGuid/activity': typeof OrdersOrderGuidJobsJobGuidActivityRoute
  '/orders/$orderGuid/jobs/$jobGuid/attachments': typeof OrdersOrderGuidJobsJobGuidAttachmentsRoute
  '/orders/$orderGuid/jobs/$jobGuid/ledger': typeof OrdersOrderGuidJobsJobGuidLedgerRoute
  '/orders/$orderGuid/jobs/$jobGuid/requests': typeof OrdersOrderGuidJobsJobGuidRequestsRoute
  '/terminals/locations/$terminalId/contacts/$contactId': typeof TerminalsLocationsTerminalIdContactsContactIdRoute
  '/terminals/locations/$terminalId/contacts/create': typeof TerminalsLocationsTerminalIdContactsCreateRoute
  '/admin/clients/$clientGuid/contacts': typeof AdminClientsClientGuidContactsIndexRoute
  '/admin/vendors/$vendorGuid/contacts': typeof AdminVendorsVendorGuidContactsIndexRoute
  '/orders/$orderGuid/jobs/$jobGuid': typeof OrdersOrderGuidJobsJobGuidIndexRoute
  '/terminals/locations/$terminalId/contacts/$contactId/merge': typeof TerminalsLocationsTerminalIdContactsContactIdMergeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/bulk-import': typeof BulkImportRouteWithChildren
  '/terminals': typeof TerminalsRouteWithChildren
  '/accounting/$type': typeof AccountingTypeRouteWithChildren
  '/admin/clients': typeof AdminClientsRouteWithChildren
  '/admin/lkq-fuel-rate': typeof AdminLkqFuelRateRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/vendors': typeof AdminVendorsRouteWithChildren
  '/bulk-import/imports': typeof BulkImportImportsRouteWithChildren
  '/bulk-import/templates': typeof BulkImportTemplatesRouteWithChildren
  '/jobs/$status': typeof JobsStatusRoute
  '/order/create': typeof OrderCreateRoute
  '/orders/$orderGuid': typeof OrdersOrderGuidRouteWithChildren
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/terminals/assignments': typeof TerminalsAssignmentsRouteWithChildren
  '/terminals/lanes': typeof TerminalsLanesRouteWithChildren
  '/terminals/locations': typeof TerminalsLocationsRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/bulk-import/': typeof BulkImportIndexRoute
  '/terminals/': typeof TerminalsIndexRoute
  '/accounting/$type/$guid': typeof AccountingTypeGuidRoute
  '/accounting/reports/$reportId': typeof AccountingReportsReportIdRoute
  '/admin/cargo-tel/configs': typeof AdminCargoTelConfigsRoute
  '/admin/clients/$clientGuid': typeof AdminClientsClientGuidRouteWithChildren
  '/admin/integrations/apps': typeof AdminIntegrationsAppsRoute
  '/admin/integrations/companies': typeof AdminIntegrationsCompaniesRoute
  '/admin/integrations/configs': typeof AdminIntegrationsConfigsRoute
  '/admin/invoices/sync-vin-amounts': typeof AdminInvoicesSyncVinAmountsRoute
  '/admin/loadboards/duplicates': typeof AdminLoadboardsDuplicatesRoute
  '/admin/loadboards/unsynced': typeof AdminLoadboardsUnsyncedRoute
  '/admin/order/case-labels': typeof AdminOrderCaseLabelsRoute
  '/admin/order/list': typeof AdminOrderListRoute
  '/admin/users/$userGuid': typeof AdminUsersUserGuidRoute
  '/admin/vendors/$vendorGuid': typeof AdminVendorsVendorGuidRouteWithChildren
  '/bulk-import/imports/$importGuid': typeof BulkImportImportsImportGuidRoute
  '/bulk-import/imports/create': typeof BulkImportImportsCreateRoute
  '/bulk-import/templates/$templateId': typeof BulkImportTemplatesTemplateIdRoute
  '/bulk-import/templates/create': typeof BulkImportTemplatesCreateRoute
  '/orders/$orderGuid/attachments': typeof OrdersOrderGuidAttachmentsRoute
  '/orders/$orderGuid/ledger': typeof OrdersOrderGuidLedgerRoute
  '/terminals/assignments/$id': typeof TerminalsAssignmentsIdRoute
  '/terminals/assignments/create': typeof TerminalsAssignmentsCreateRoute
  '/terminals/lanes/$id': typeof TerminalsLanesIdRoute
  '/terminals/lanes/create': typeof TerminalsLanesCreateRoute
  '/terminals/locations/$terminalId': typeof TerminalsLocationsTerminalIdRoute
  '/terminals/locations/create': typeof TerminalsLocationsCreateRoute
  '/accounting/$type/': typeof AccountingTypeIndexRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/vendors/': typeof AdminVendorsIndexRoute
  '/bulk-import/imports/': typeof BulkImportImportsIndexRoute
  '/bulk-import/templates/': typeof BulkImportTemplatesIndexRoute
  '/orders/$orderGuid/': typeof OrdersOrderGuidIndexRoute
  '/admin/clients/$clientGuid/contacts': typeof AdminClientsClientGuidContactsRouteWithChildren
  '/admin/order/reports/$reportId': typeof AdminOrderReportsReportIdRoute
  '/admin/vendors/$vendorGuid/contacts': typeof AdminVendorsVendorGuidContactsRouteWithChildren
  '/orders/$orderGuid_/jobs/$jobGuid': typeof OrdersOrderGuidJobsJobGuidRouteWithChildren
  '/orders/$orderGuid_/jobs/create': typeof OrdersOrderGuidJobsCreateRoute
  '/terminals/locations/$terminalId_/contacts': typeof TerminalsLocationsTerminalIdContactsRouteWithChildren
  '/terminals/locations/$terminalId_/merge': typeof TerminalsLocationsTerminalIdMergeRoute
  '/admin/clients/$clientGuid/': typeof AdminClientsClientGuidIndexRoute
  '/admin/vendors/$vendorGuid/': typeof AdminVendorsVendorGuidIndexRoute
  '/admin/clients/$clientGuid/contacts/$contactGuid': typeof AdminClientsClientGuidContactsContactGuidRoute
  '/admin/vendors/$vendorGuid/contacts/$contactGuid': typeof AdminVendorsVendorGuidContactsContactGuidRoute
  '/orders/$orderGuid_/jobs/$jobGuid/activity': typeof OrdersOrderGuidJobsJobGuidActivityRoute
  '/orders/$orderGuid_/jobs/$jobGuid/attachments': typeof OrdersOrderGuidJobsJobGuidAttachmentsRoute
  '/orders/$orderGuid_/jobs/$jobGuid/ledger': typeof OrdersOrderGuidJobsJobGuidLedgerRoute
  '/orders/$orderGuid_/jobs/$jobGuid/requests': typeof OrdersOrderGuidJobsJobGuidRequestsRoute
  '/terminals/locations/$terminalId_/contacts/$contactId': typeof TerminalsLocationsTerminalIdContactsContactIdRoute
  '/terminals/locations/$terminalId_/contacts/create': typeof TerminalsLocationsTerminalIdContactsCreateRoute
  '/admin/clients/$clientGuid/contacts/': typeof AdminClientsClientGuidContactsIndexRoute
  '/admin/vendors/$vendorGuid/contacts/': typeof AdminVendorsVendorGuidContactsIndexRoute
  '/orders/$orderGuid_/jobs/$jobGuid/': typeof OrdersOrderGuidJobsJobGuidIndexRoute
  '/terminals/locations/$terminalId_/contacts/$contactId_/merge': typeof TerminalsLocationsTerminalIdContactsContactIdMergeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounting'
    | '/admin'
    | '/bulk-import'
    | '/terminals'
    | '/accounting/$type'
    | '/admin/clients'
    | '/admin/lkq-fuel-rate'
    | '/admin/users'
    | '/admin/vendors'
    | '/bulk-import/imports'
    | '/bulk-import/templates'
    | '/jobs/$status'
    | '/order/create'
    | '/orders/$orderGuid'
    | '/reports/$reportId'
    | '/terminals/assignments'
    | '/terminals/lanes'
    | '/terminals/locations'
    | '/admin/'
    | '/bulk-import/'
    | '/terminals/'
    | '/accounting/$type/$guid'
    | '/accounting/reports/$reportId'
    | '/admin/cargo-tel/configs'
    | '/admin/clients/$clientGuid'
    | '/admin/integrations/apps'
    | '/admin/integrations/companies'
    | '/admin/integrations/configs'
    | '/admin/invoices/sync-vin-amounts'
    | '/admin/loadboards/duplicates'
    | '/admin/loadboards/unsynced'
    | '/admin/order/case-labels'
    | '/admin/order/list'
    | '/admin/users/$userGuid'
    | '/admin/vendors/$vendorGuid'
    | '/bulk-import/imports/$importGuid'
    | '/bulk-import/imports/create'
    | '/bulk-import/templates/$templateId'
    | '/bulk-import/templates/create'
    | '/orders/$orderGuid/attachments'
    | '/orders/$orderGuid/ledger'
    | '/terminals/assignments/$id'
    | '/terminals/assignments/create'
    | '/terminals/lanes/$id'
    | '/terminals/lanes/create'
    | '/terminals/locations/$terminalId'
    | '/terminals/locations/create'
    | '/accounting/$type/'
    | '/admin/clients/'
    | '/admin/users/'
    | '/admin/vendors/'
    | '/bulk-import/imports/'
    | '/bulk-import/templates/'
    | '/orders/$orderGuid/'
    | '/admin/clients/$clientGuid/contacts'
    | '/admin/order/reports/$reportId'
    | '/admin/vendors/$vendorGuid/contacts'
    | '/orders/$orderGuid/jobs/$jobGuid'
    | '/orders/$orderGuid/jobs/create'
    | '/terminals/locations/$terminalId/contacts'
    | '/terminals/locations/$terminalId/merge'
    | '/admin/clients/$clientGuid/'
    | '/admin/vendors/$vendorGuid/'
    | '/admin/clients/$clientGuid/contacts/$contactGuid'
    | '/admin/vendors/$vendorGuid/contacts/$contactGuid'
    | '/orders/$orderGuid/jobs/$jobGuid/activity'
    | '/orders/$orderGuid/jobs/$jobGuid/attachments'
    | '/orders/$orderGuid/jobs/$jobGuid/ledger'
    | '/orders/$orderGuid/jobs/$jobGuid/requests'
    | '/terminals/locations/$terminalId/contacts/$contactId'
    | '/terminals/locations/$terminalId/contacts/create'
    | '/admin/clients/$clientGuid/contacts/'
    | '/admin/vendors/$vendorGuid/contacts/'
    | '/orders/$orderGuid/jobs/$jobGuid/'
    | '/terminals/locations/$terminalId/contacts/$contactId/merge'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accounting'
    | '/admin/lkq-fuel-rate'
    | '/jobs/$status'
    | '/order/create'
    | '/reports/$reportId'
    | '/terminals/assignments'
    | '/terminals/lanes'
    | '/terminals/locations'
    | '/admin'
    | '/bulk-import'
    | '/terminals'
    | '/accounting/$type/$guid'
    | '/accounting/reports/$reportId'
    | '/admin/cargo-tel/configs'
    | '/admin/integrations/apps'
    | '/admin/integrations/companies'
    | '/admin/integrations/configs'
    | '/admin/invoices/sync-vin-amounts'
    | '/admin/loadboards/duplicates'
    | '/admin/loadboards/unsynced'
    | '/admin/order/case-labels'
    | '/admin/order/list'
    | '/admin/users/$userGuid'
    | '/bulk-import/imports/$importGuid'
    | '/bulk-import/imports/create'
    | '/bulk-import/templates/$templateId'
    | '/bulk-import/templates/create'
    | '/orders/$orderGuid/attachments'
    | '/orders/$orderGuid/ledger'
    | '/terminals/assignments/$id'
    | '/terminals/assignments/create'
    | '/terminals/lanes/$id'
    | '/terminals/lanes/create'
    | '/terminals/locations/$terminalId'
    | '/terminals/locations/create'
    | '/accounting/$type'
    | '/admin/clients'
    | '/admin/users'
    | '/admin/vendors'
    | '/bulk-import/imports'
    | '/bulk-import/templates'
    | '/orders/$orderGuid'
    | '/admin/order/reports/$reportId'
    | '/orders/$orderGuid/jobs/create'
    | '/terminals/locations/$terminalId/contacts'
    | '/terminals/locations/$terminalId/merge'
    | '/admin/clients/$clientGuid'
    | '/admin/vendors/$vendorGuid'
    | '/admin/clients/$clientGuid/contacts/$contactGuid'
    | '/admin/vendors/$vendorGuid/contacts/$contactGuid'
    | '/orders/$orderGuid/jobs/$jobGuid/activity'
    | '/orders/$orderGuid/jobs/$jobGuid/attachments'
    | '/orders/$orderGuid/jobs/$jobGuid/ledger'
    | '/orders/$orderGuid/jobs/$jobGuid/requests'
    | '/terminals/locations/$terminalId/contacts/$contactId'
    | '/terminals/locations/$terminalId/contacts/create'
    | '/admin/clients/$clientGuid/contacts'
    | '/admin/vendors/$vendorGuid/contacts'
    | '/orders/$orderGuid/jobs/$jobGuid'
    | '/terminals/locations/$terminalId/contacts/$contactId/merge'
  id:
    | '__root__'
    | '/'
    | '/accounting'
    | '/admin'
    | '/bulk-import'
    | '/terminals'
    | '/accounting/$type'
    | '/admin/clients'
    | '/admin/lkq-fuel-rate'
    | '/admin/users'
    | '/admin/vendors'
    | '/bulk-import/imports'
    | '/bulk-import/templates'
    | '/jobs/$status'
    | '/order/create'
    | '/orders/$orderGuid'
    | '/reports/$reportId'
    | '/terminals/assignments'
    | '/terminals/lanes'
    | '/terminals/locations'
    | '/admin/'
    | '/bulk-import/'
    | '/terminals/'
    | '/accounting/$type/$guid'
    | '/accounting/reports/$reportId'
    | '/admin/cargo-tel/configs'
    | '/admin/clients/$clientGuid'
    | '/admin/integrations/apps'
    | '/admin/integrations/companies'
    | '/admin/integrations/configs'
    | '/admin/invoices/sync-vin-amounts'
    | '/admin/loadboards/duplicates'
    | '/admin/loadboards/unsynced'
    | '/admin/order/case-labels'
    | '/admin/order/list'
    | '/admin/users/$userGuid'
    | '/admin/vendors/$vendorGuid'
    | '/bulk-import/imports/$importGuid'
    | '/bulk-import/imports/create'
    | '/bulk-import/templates/$templateId'
    | '/bulk-import/templates/create'
    | '/orders/$orderGuid/attachments'
    | '/orders/$orderGuid/ledger'
    | '/terminals/assignments/$id'
    | '/terminals/assignments/create'
    | '/terminals/lanes/$id'
    | '/terminals/lanes/create'
    | '/terminals/locations/$terminalId'
    | '/terminals/locations/create'
    | '/accounting/$type/'
    | '/admin/clients/'
    | '/admin/users/'
    | '/admin/vendors/'
    | '/bulk-import/imports/'
    | '/bulk-import/templates/'
    | '/orders/$orderGuid/'
    | '/admin/clients/$clientGuid/contacts'
    | '/admin/order/reports/$reportId'
    | '/admin/vendors/$vendorGuid/contacts'
    | '/orders/$orderGuid_/jobs/$jobGuid'
    | '/orders/$orderGuid_/jobs/create'
    | '/terminals/locations/$terminalId_/contacts'
    | '/terminals/locations/$terminalId_/merge'
    | '/admin/clients/$clientGuid/'
    | '/admin/vendors/$vendorGuid/'
    | '/admin/clients/$clientGuid/contacts/$contactGuid'
    | '/admin/vendors/$vendorGuid/contacts/$contactGuid'
    | '/orders/$orderGuid_/jobs/$jobGuid/activity'
    | '/orders/$orderGuid_/jobs/$jobGuid/attachments'
    | '/orders/$orderGuid_/jobs/$jobGuid/ledger'
    | '/orders/$orderGuid_/jobs/$jobGuid/requests'
    | '/terminals/locations/$terminalId_/contacts/$contactId'
    | '/terminals/locations/$terminalId_/contacts/create'
    | '/admin/clients/$clientGuid/contacts/'
    | '/admin/vendors/$vendorGuid/contacts/'
    | '/orders/$orderGuid_/jobs/$jobGuid/'
    | '/terminals/locations/$terminalId_/contacts/$contactId_/merge'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountingRoute: typeof AccountingRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  BulkImportRoute: typeof BulkImportRouteWithChildren
  TerminalsRoute: typeof TerminalsRouteWithChildren
  JobsStatusRoute: typeof JobsStatusRoute
  OrderCreateRoute: typeof OrderCreateRoute
  OrdersOrderGuidRoute: typeof OrdersOrderGuidRouteWithChildren
  ReportsReportIdRoute: typeof ReportsReportIdRoute
  OrdersOrderGuidJobsJobGuidRoute: typeof OrdersOrderGuidJobsJobGuidRouteWithChildren
  OrdersOrderGuidJobsCreateRoute: typeof OrdersOrderGuidJobsCreateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting': {
      id: '/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AccountingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bulk-import': {
      id: '/bulk-import'
      path: '/bulk-import'
      fullPath: '/bulk-import'
      preLoaderRoute: typeof BulkImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terminals': {
      id: '/terminals'
      path: '/terminals'
      fullPath: '/terminals'
      preLoaderRoute: typeof TerminalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/$type': {
      id: '/accounting/$type'
      path: '/$type'
      fullPath: '/accounting/$type'
      preLoaderRoute: typeof AccountingTypeRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clients': {
      id: '/admin/clients'
      path: '/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof AdminClientsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/lkq-fuel-rate': {
      id: '/admin/lkq-fuel-rate'
      path: '/lkq-fuel-rate'
      fullPath: '/admin/lkq-fuel-rate'
      preLoaderRoute: typeof AdminLkqFuelRateRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/vendors': {
      id: '/admin/vendors'
      path: '/vendors'
      fullPath: '/admin/vendors'
      preLoaderRoute: typeof AdminVendorsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/bulk-import/': {
      id: '/bulk-import/'
      path: '/'
      fullPath: '/bulk-import/'
      preLoaderRoute: typeof BulkImportIndexRouteImport
      parentRoute: typeof BulkImportRoute
    }
    '/bulk-import/imports': {
      id: '/bulk-import/imports'
      path: '/imports'
      fullPath: '/bulk-import/imports'
      preLoaderRoute: typeof BulkImportImportsRouteImport
      parentRoute: typeof BulkImportRoute
    }
    '/bulk-import/templates': {
      id: '/bulk-import/templates'
      path: '/templates'
      fullPath: '/bulk-import/templates'
      preLoaderRoute: typeof BulkImportTemplatesRouteImport
      parentRoute: typeof BulkImportRoute
    }
    '/jobs/$status': {
      id: '/jobs/$status'
      path: '/jobs/$status'
      fullPath: '/jobs/$status'
      preLoaderRoute: typeof JobsStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/create': {
      id: '/order/create'
      path: '/order/create'
      fullPath: '/order/create'
      preLoaderRoute: typeof OrderCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderGuid': {
      id: '/orders/$orderGuid'
      path: '/orders/$orderGuid'
      fullPath: '/orders/$orderGuid'
      preLoaderRoute: typeof OrdersOrderGuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/$reportId': {
      id: '/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof ReportsReportIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terminals/': {
      id: '/terminals/'
      path: '/'
      fullPath: '/terminals/'
      preLoaderRoute: typeof TerminalsIndexRouteImport
      parentRoute: typeof TerminalsRoute
    }
    '/terminals/assignments': {
      id: '/terminals/assignments'
      path: '/assignments'
      fullPath: '/terminals/assignments'
      preLoaderRoute: typeof TerminalsAssignmentsRouteImport
      parentRoute: typeof TerminalsRoute
    }
    '/terminals/lanes': {
      id: '/terminals/lanes'
      path: '/lanes'
      fullPath: '/terminals/lanes'
      preLoaderRoute: typeof TerminalsLanesRouteImport
      parentRoute: typeof TerminalsRoute
    }
    '/terminals/locations': {
      id: '/terminals/locations'
      path: '/locations'
      fullPath: '/terminals/locations'
      preLoaderRoute: typeof TerminalsLocationsRouteImport
      parentRoute: typeof TerminalsRoute
    }
    '/accounting/$type/': {
      id: '/accounting/$type/'
      path: '/'
      fullPath: '/accounting/$type/'
      preLoaderRoute: typeof AccountingTypeIndexRouteImport
      parentRoute: typeof AccountingTypeRoute
    }
    '/accounting/$type/$guid': {
      id: '/accounting/$type/$guid'
      path: '/$guid'
      fullPath: '/accounting/$type/$guid'
      preLoaderRoute: typeof AccountingTypeGuidRouteImport
      parentRoute: typeof AccountingTypeRoute
    }
    '/accounting/reports/$reportId': {
      id: '/accounting/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/accounting/reports/$reportId'
      preLoaderRoute: typeof AccountingReportsReportIdRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/admin/cargo-tel/configs': {
      id: '/admin/cargo-tel/configs'
      path: '/cargo-tel/configs'
      fullPath: '/admin/cargo-tel/configs'
      preLoaderRoute: typeof AdminCargoTelConfigsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clients/': {
      id: '/admin/clients/'
      path: '/'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AdminClientsIndexRouteImport
      parentRoute: typeof AdminClientsRoute
    }
    '/admin/clients/$clientGuid': {
      id: '/admin/clients/$clientGuid'
      path: '/$clientGuid'
      fullPath: '/admin/clients/$clientGuid'
      preLoaderRoute: typeof AdminClientsClientGuidRouteImport
      parentRoute: typeof AdminClientsRoute
    }
    '/admin/integrations/apps': {
      id: '/admin/integrations/apps'
      path: '/integrations/apps'
      fullPath: '/admin/integrations/apps'
      preLoaderRoute: typeof AdminIntegrationsAppsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/integrations/companies': {
      id: '/admin/integrations/companies'
      path: '/integrations/companies'
      fullPath: '/admin/integrations/companies'
      preLoaderRoute: typeof AdminIntegrationsCompaniesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/integrations/configs': {
      id: '/admin/integrations/configs'
      path: '/integrations/configs'
      fullPath: '/admin/integrations/configs'
      preLoaderRoute: typeof AdminIntegrationsConfigsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invoices/sync-vin-amounts': {
      id: '/admin/invoices/sync-vin-amounts'
      path: '/invoices/sync-vin-amounts'
      fullPath: '/admin/invoices/sync-vin-amounts'
      preLoaderRoute: typeof AdminInvoicesSyncVinAmountsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/loadboards/duplicates': {
      id: '/admin/loadboards/duplicates'
      path: '/loadboards/duplicates'
      fullPath: '/admin/loadboards/duplicates'
      preLoaderRoute: typeof AdminLoadboardsDuplicatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/loadboards/unsynced': {
      id: '/admin/loadboards/unsynced'
      path: '/loadboards/unsynced'
      fullPath: '/admin/loadboards/unsynced'
      preLoaderRoute: typeof AdminLoadboardsUnsyncedRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/order/case-labels': {
      id: '/admin/order/case-labels'
      path: '/order/case-labels'
      fullPath: '/admin/order/case-labels'
      preLoaderRoute: typeof AdminOrderCaseLabelsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/order/list': {
      id: '/admin/order/list'
      path: '/order/list'
      fullPath: '/admin/order/list'
      preLoaderRoute: typeof AdminOrderListRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/users/$userGuid': {
      id: '/admin/users/$userGuid'
      path: '/$userGuid'
      fullPath: '/admin/users/$userGuid'
      preLoaderRoute: typeof AdminUsersUserGuidRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/vendors/': {
      id: '/admin/vendors/'
      path: '/'
      fullPath: '/admin/vendors/'
      preLoaderRoute: typeof AdminVendorsIndexRouteImport
      parentRoute: typeof AdminVendorsRoute
    }
    '/admin/vendors/$vendorGuid': {
      id: '/admin/vendors/$vendorGuid'
      path: '/$vendorGuid'
      fullPath: '/admin/vendors/$vendorGuid'
      preLoaderRoute: typeof AdminVendorsVendorGuidRouteImport
      parentRoute: typeof AdminVendorsRoute
    }
    '/bulk-import/imports/': {
      id: '/bulk-import/imports/'
      path: '/'
      fullPath: '/bulk-import/imports/'
      preLoaderRoute: typeof BulkImportImportsIndexRouteImport
      parentRoute: typeof BulkImportImportsRoute
    }
    '/bulk-import/imports/$importGuid': {
      id: '/bulk-import/imports/$importGuid'
      path: '/$importGuid'
      fullPath: '/bulk-import/imports/$importGuid'
      preLoaderRoute: typeof BulkImportImportsImportGuidRouteImport
      parentRoute: typeof BulkImportImportsRoute
    }
    '/bulk-import/imports/create': {
      id: '/bulk-import/imports/create'
      path: '/create'
      fullPath: '/bulk-import/imports/create'
      preLoaderRoute: typeof BulkImportImportsCreateRouteImport
      parentRoute: typeof BulkImportImportsRoute
    }
    '/bulk-import/templates/': {
      id: '/bulk-import/templates/'
      path: '/'
      fullPath: '/bulk-import/templates/'
      preLoaderRoute: typeof BulkImportTemplatesIndexRouteImport
      parentRoute: typeof BulkImportTemplatesRoute
    }
    '/bulk-import/templates/$templateId': {
      id: '/bulk-import/templates/$templateId'
      path: '/$templateId'
      fullPath: '/bulk-import/templates/$templateId'
      preLoaderRoute: typeof BulkImportTemplatesTemplateIdRouteImport
      parentRoute: typeof BulkImportTemplatesRoute
    }
    '/bulk-import/templates/create': {
      id: '/bulk-import/templates/create'
      path: '/create'
      fullPath: '/bulk-import/templates/create'
      preLoaderRoute: typeof BulkImportTemplatesCreateRouteImport
      parentRoute: typeof BulkImportTemplatesRoute
    }
    '/orders/$orderGuid/': {
      id: '/orders/$orderGuid/'
      path: '/'
      fullPath: '/orders/$orderGuid/'
      preLoaderRoute: typeof OrdersOrderGuidIndexRouteImport
      parentRoute: typeof OrdersOrderGuidRoute
    }
    '/orders/$orderGuid/attachments': {
      id: '/orders/$orderGuid/attachments'
      path: '/attachments'
      fullPath: '/orders/$orderGuid/attachments'
      preLoaderRoute: typeof OrdersOrderGuidAttachmentsRouteImport
      parentRoute: typeof OrdersOrderGuidRoute
    }
    '/orders/$orderGuid/ledger': {
      id: '/orders/$orderGuid/ledger'
      path: '/ledger'
      fullPath: '/orders/$orderGuid/ledger'
      preLoaderRoute: typeof OrdersOrderGuidLedgerRouteImport
      parentRoute: typeof OrdersOrderGuidRoute
    }
    '/terminals/assignments/$id': {
      id: '/terminals/assignments/$id'
      path: '/$id'
      fullPath: '/terminals/assignments/$id'
      preLoaderRoute: typeof TerminalsAssignmentsIdRouteImport
      parentRoute: typeof TerminalsAssignmentsRoute
    }
    '/terminals/assignments/create': {
      id: '/terminals/assignments/create'
      path: '/create'
      fullPath: '/terminals/assignments/create'
      preLoaderRoute: typeof TerminalsAssignmentsCreateRouteImport
      parentRoute: typeof TerminalsAssignmentsRoute
    }
    '/terminals/lanes/$id': {
      id: '/terminals/lanes/$id'
      path: '/$id'
      fullPath: '/terminals/lanes/$id'
      preLoaderRoute: typeof TerminalsLanesIdRouteImport
      parentRoute: typeof TerminalsLanesRoute
    }
    '/terminals/lanes/create': {
      id: '/terminals/lanes/create'
      path: '/create'
      fullPath: '/terminals/lanes/create'
      preLoaderRoute: typeof TerminalsLanesCreateRouteImport
      parentRoute: typeof TerminalsLanesRoute
    }
    '/terminals/locations/$terminalId': {
      id: '/terminals/locations/$terminalId'
      path: '/$terminalId'
      fullPath: '/terminals/locations/$terminalId'
      preLoaderRoute: typeof TerminalsLocationsTerminalIdRouteImport
      parentRoute: typeof TerminalsLocationsRoute
    }
    '/terminals/locations/create': {
      id: '/terminals/locations/create'
      path: '/create'
      fullPath: '/terminals/locations/create'
      preLoaderRoute: typeof TerminalsLocationsCreateRouteImport
      parentRoute: typeof TerminalsLocationsRoute
    }
    '/admin/clients/$clientGuid/': {
      id: '/admin/clients/$clientGuid/'
      path: '/'
      fullPath: '/admin/clients/$clientGuid/'
      preLoaderRoute: typeof AdminClientsClientGuidIndexRouteImport
      parentRoute: typeof AdminClientsClientGuidRoute
    }
    '/admin/clients/$clientGuid/contacts': {
      id: '/admin/clients/$clientGuid/contacts'
      path: '/contacts'
      fullPath: '/admin/clients/$clientGuid/contacts'
      preLoaderRoute: typeof AdminClientsClientGuidContactsRouteImport
      parentRoute: typeof AdminClientsClientGuidRoute
    }
    '/admin/order/reports/$reportId': {
      id: '/admin/order/reports/$reportId'
      path: '/order/reports/$reportId'
      fullPath: '/admin/order/reports/$reportId'
      preLoaderRoute: typeof AdminOrderReportsReportIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/vendors/$vendorGuid/': {
      id: '/admin/vendors/$vendorGuid/'
      path: '/'
      fullPath: '/admin/vendors/$vendorGuid/'
      preLoaderRoute: typeof AdminVendorsVendorGuidIndexRouteImport
      parentRoute: typeof AdminVendorsVendorGuidRoute
    }
    '/admin/vendors/$vendorGuid/contacts': {
      id: '/admin/vendors/$vendorGuid/contacts'
      path: '/contacts'
      fullPath: '/admin/vendors/$vendorGuid/contacts'
      preLoaderRoute: typeof AdminVendorsVendorGuidContactsRouteImport
      parentRoute: typeof AdminVendorsVendorGuidRoute
    }
    '/orders/$orderGuid_/jobs/$jobGuid': {
      id: '/orders/$orderGuid_/jobs/$jobGuid'
      path: '/orders/$orderGuid/jobs/$jobGuid'
      fullPath: '/orders/$orderGuid/jobs/$jobGuid'
      preLoaderRoute: typeof OrdersOrderGuidJobsJobGuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderGuid_/jobs/create': {
      id: '/orders/$orderGuid_/jobs/create'
      path: '/orders/$orderGuid/jobs/create'
      fullPath: '/orders/$orderGuid/jobs/create'
      preLoaderRoute: typeof OrdersOrderGuidJobsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terminals/locations/$terminalId_/contacts': {
      id: '/terminals/locations/$terminalId_/contacts'
      path: '/$terminalId/contacts'
      fullPath: '/terminals/locations/$terminalId/contacts'
      preLoaderRoute: typeof TerminalsLocationsTerminalIdContactsRouteImport
      parentRoute: typeof TerminalsLocationsRoute
    }
    '/terminals/locations/$terminalId_/merge': {
      id: '/terminals/locations/$terminalId_/merge'
      path: '/$terminalId/merge'
      fullPath: '/terminals/locations/$terminalId/merge'
      preLoaderRoute: typeof TerminalsLocationsTerminalIdMergeRouteImport
      parentRoute: typeof TerminalsLocationsRoute
    }
    '/admin/clients/$clientGuid/contacts/': {
      id: '/admin/clients/$clientGuid/contacts/'
      path: '/'
      fullPath: '/admin/clients/$clientGuid/contacts/'
      preLoaderRoute: typeof AdminClientsClientGuidContactsIndexRouteImport
      parentRoute: typeof AdminClientsClientGuidContactsRoute
    }
    '/admin/clients/$clientGuid/contacts/$contactGuid': {
      id: '/admin/clients/$clientGuid/contacts/$contactGuid'
      path: '/$contactGuid'
      fullPath: '/admin/clients/$clientGuid/contacts/$contactGuid'
      preLoaderRoute: typeof AdminClientsClientGuidContactsContactGuidRouteImport
      parentRoute: typeof AdminClientsClientGuidContactsRoute
    }
    '/admin/vendors/$vendorGuid/contacts/': {
      id: '/admin/vendors/$vendorGuid/contacts/'
      path: '/'
      fullPath: '/admin/vendors/$vendorGuid/contacts/'
      preLoaderRoute: typeof AdminVendorsVendorGuidContactsIndexRouteImport
      parentRoute: typeof AdminVendorsVendorGuidContactsRoute
    }
    '/admin/vendors/$vendorGuid/contacts/$contactGuid': {
      id: '/admin/vendors/$vendorGuid/contacts/$contactGuid'
      path: '/$contactGuid'
      fullPath: '/admin/vendors/$vendorGuid/contacts/$contactGuid'
      preLoaderRoute: typeof AdminVendorsVendorGuidContactsContactGuidRouteImport
      parentRoute: typeof AdminVendorsVendorGuidContactsRoute
    }
    '/orders/$orderGuid_/jobs/$jobGuid/': {
      id: '/orders/$orderGuid_/jobs/$jobGuid/'
      path: '/'
      fullPath: '/orders/$orderGuid/jobs/$jobGuid/'
      preLoaderRoute: typeof OrdersOrderGuidJobsJobGuidIndexRouteImport
      parentRoute: typeof OrdersOrderGuidJobsJobGuidRoute
    }
    '/orders/$orderGuid_/jobs/$jobGuid/activity': {
      id: '/orders/$orderGuid_/jobs/$jobGuid/activity'
      path: '/activity'
      fullPath: '/orders/$orderGuid/jobs/$jobGuid/activity'
      preLoaderRoute: typeof OrdersOrderGuidJobsJobGuidActivityRouteImport
      parentRoute: typeof OrdersOrderGuidJobsJobGuidRoute
    }
    '/orders/$orderGuid_/jobs/$jobGuid/attachments': {
      id: '/orders/$orderGuid_/jobs/$jobGuid/attachments'
      path: '/attachments'
      fullPath: '/orders/$orderGuid/jobs/$jobGuid/attachments'
      preLoaderRoute: typeof OrdersOrderGuidJobsJobGuidAttachmentsRouteImport
      parentRoute: typeof OrdersOrderGuidJobsJobGuidRoute
    }
    '/orders/$orderGuid_/jobs/$jobGuid/ledger': {
      id: '/orders/$orderGuid_/jobs/$jobGuid/ledger'
      path: '/ledger'
      fullPath: '/orders/$orderGuid/jobs/$jobGuid/ledger'
      preLoaderRoute: typeof OrdersOrderGuidJobsJobGuidLedgerRouteImport
      parentRoute: typeof OrdersOrderGuidJobsJobGuidRoute
    }
    '/orders/$orderGuid_/jobs/$jobGuid/requests': {
      id: '/orders/$orderGuid_/jobs/$jobGuid/requests'
      path: '/requests'
      fullPath: '/orders/$orderGuid/jobs/$jobGuid/requests'
      preLoaderRoute: typeof OrdersOrderGuidJobsJobGuidRequestsRouteImport
      parentRoute: typeof OrdersOrderGuidJobsJobGuidRoute
    }
    '/terminals/locations/$terminalId_/contacts/$contactId': {
      id: '/terminals/locations/$terminalId_/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/terminals/locations/$terminalId/contacts/$contactId'
      preLoaderRoute: typeof TerminalsLocationsTerminalIdContactsContactIdRouteImport
      parentRoute: typeof TerminalsLocationsTerminalIdContactsRoute
    }
    '/terminals/locations/$terminalId_/contacts/create': {
      id: '/terminals/locations/$terminalId_/contacts/create'
      path: '/create'
      fullPath: '/terminals/locations/$terminalId/contacts/create'
      preLoaderRoute: typeof TerminalsLocationsTerminalIdContactsCreateRouteImport
      parentRoute: typeof TerminalsLocationsTerminalIdContactsRoute
    }
    '/terminals/locations/$terminalId_/contacts/$contactId_/merge': {
      id: '/terminals/locations/$terminalId_/contacts/$contactId_/merge'
      path: '/$contactId/merge'
      fullPath: '/terminals/locations/$terminalId/contacts/$contactId/merge'
      preLoaderRoute: typeof TerminalsLocationsTerminalIdContactsContactIdMergeRouteImport
      parentRoute: typeof TerminalsLocationsTerminalIdContactsRoute
    }
  }
}

interface AccountingTypeRouteChildren {
  AccountingTypeGuidRoute: typeof AccountingTypeGuidRoute
  AccountingTypeIndexRoute: typeof AccountingTypeIndexRoute
}

const AccountingTypeRouteChildren: AccountingTypeRouteChildren = {
  AccountingTypeGuidRoute: AccountingTypeGuidRoute,
  AccountingTypeIndexRoute: AccountingTypeIndexRoute,
}

const AccountingTypeRouteWithChildren = AccountingTypeRoute._addFileChildren(
  AccountingTypeRouteChildren,
)

interface AccountingRouteChildren {
  AccountingTypeRoute: typeof AccountingTypeRouteWithChildren
  AccountingReportsReportIdRoute: typeof AccountingReportsReportIdRoute
}

const AccountingRouteChildren: AccountingRouteChildren = {
  AccountingTypeRoute: AccountingTypeRouteWithChildren,
  AccountingReportsReportIdRoute: AccountingReportsReportIdRoute,
}

const AccountingRouteWithChildren = AccountingRoute._addFileChildren(
  AccountingRouteChildren,
)

interface AdminClientsClientGuidContactsRouteChildren {
  AdminClientsClientGuidContactsContactGuidRoute: typeof AdminClientsClientGuidContactsContactGuidRoute
  AdminClientsClientGuidContactsIndexRoute: typeof AdminClientsClientGuidContactsIndexRoute
}

const AdminClientsClientGuidContactsRouteChildren: AdminClientsClientGuidContactsRouteChildren =
  {
    AdminClientsClientGuidContactsContactGuidRoute:
      AdminClientsClientGuidContactsContactGuidRoute,
    AdminClientsClientGuidContactsIndexRoute:
      AdminClientsClientGuidContactsIndexRoute,
  }

const AdminClientsClientGuidContactsRouteWithChildren =
  AdminClientsClientGuidContactsRoute._addFileChildren(
    AdminClientsClientGuidContactsRouteChildren,
  )

interface AdminClientsClientGuidRouteChildren {
  AdminClientsClientGuidContactsRoute: typeof AdminClientsClientGuidContactsRouteWithChildren
  AdminClientsClientGuidIndexRoute: typeof AdminClientsClientGuidIndexRoute
}

const AdminClientsClientGuidRouteChildren: AdminClientsClientGuidRouteChildren =
  {
    AdminClientsClientGuidContactsRoute:
      AdminClientsClientGuidContactsRouteWithChildren,
    AdminClientsClientGuidIndexRoute: AdminClientsClientGuidIndexRoute,
  }

const AdminClientsClientGuidRouteWithChildren =
  AdminClientsClientGuidRoute._addFileChildren(
    AdminClientsClientGuidRouteChildren,
  )

interface AdminClientsRouteChildren {
  AdminClientsClientGuidRoute: typeof AdminClientsClientGuidRouteWithChildren
  AdminClientsIndexRoute: typeof AdminClientsIndexRoute
}

const AdminClientsRouteChildren: AdminClientsRouteChildren = {
  AdminClientsClientGuidRoute: AdminClientsClientGuidRouteWithChildren,
  AdminClientsIndexRoute: AdminClientsIndexRoute,
}

const AdminClientsRouteWithChildren = AdminClientsRoute._addFileChildren(
  AdminClientsRouteChildren,
)

interface AdminUsersRouteChildren {
  AdminUsersUserGuidRoute: typeof AdminUsersUserGuidRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersUserGuidRoute: AdminUsersUserGuidRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminVendorsVendorGuidContactsRouteChildren {
  AdminVendorsVendorGuidContactsContactGuidRoute: typeof AdminVendorsVendorGuidContactsContactGuidRoute
  AdminVendorsVendorGuidContactsIndexRoute: typeof AdminVendorsVendorGuidContactsIndexRoute
}

const AdminVendorsVendorGuidContactsRouteChildren: AdminVendorsVendorGuidContactsRouteChildren =
  {
    AdminVendorsVendorGuidContactsContactGuidRoute:
      AdminVendorsVendorGuidContactsContactGuidRoute,
    AdminVendorsVendorGuidContactsIndexRoute:
      AdminVendorsVendorGuidContactsIndexRoute,
  }

const AdminVendorsVendorGuidContactsRouteWithChildren =
  AdminVendorsVendorGuidContactsRoute._addFileChildren(
    AdminVendorsVendorGuidContactsRouteChildren,
  )

interface AdminVendorsVendorGuidRouteChildren {
  AdminVendorsVendorGuidContactsRoute: typeof AdminVendorsVendorGuidContactsRouteWithChildren
  AdminVendorsVendorGuidIndexRoute: typeof AdminVendorsVendorGuidIndexRoute
}

const AdminVendorsVendorGuidRouteChildren: AdminVendorsVendorGuidRouteChildren =
  {
    AdminVendorsVendorGuidContactsRoute:
      AdminVendorsVendorGuidContactsRouteWithChildren,
    AdminVendorsVendorGuidIndexRoute: AdminVendorsVendorGuidIndexRoute,
  }

const AdminVendorsVendorGuidRouteWithChildren =
  AdminVendorsVendorGuidRoute._addFileChildren(
    AdminVendorsVendorGuidRouteChildren,
  )

interface AdminVendorsRouteChildren {
  AdminVendorsVendorGuidRoute: typeof AdminVendorsVendorGuidRouteWithChildren
  AdminVendorsIndexRoute: typeof AdminVendorsIndexRoute
}

const AdminVendorsRouteChildren: AdminVendorsRouteChildren = {
  AdminVendorsVendorGuidRoute: AdminVendorsVendorGuidRouteWithChildren,
  AdminVendorsIndexRoute: AdminVendorsIndexRoute,
}

const AdminVendorsRouteWithChildren = AdminVendorsRoute._addFileChildren(
  AdminVendorsRouteChildren,
)

interface AdminRouteChildren {
  AdminClientsRoute: typeof AdminClientsRouteWithChildren
  AdminLkqFuelRateRoute: typeof AdminLkqFuelRateRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminVendorsRoute: typeof AdminVendorsRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCargoTelConfigsRoute: typeof AdminCargoTelConfigsRoute
  AdminIntegrationsAppsRoute: typeof AdminIntegrationsAppsRoute
  AdminIntegrationsCompaniesRoute: typeof AdminIntegrationsCompaniesRoute
  AdminIntegrationsConfigsRoute: typeof AdminIntegrationsConfigsRoute
  AdminInvoicesSyncVinAmountsRoute: typeof AdminInvoicesSyncVinAmountsRoute
  AdminLoadboardsDuplicatesRoute: typeof AdminLoadboardsDuplicatesRoute
  AdminLoadboardsUnsyncedRoute: typeof AdminLoadboardsUnsyncedRoute
  AdminOrderCaseLabelsRoute: typeof AdminOrderCaseLabelsRoute
  AdminOrderListRoute: typeof AdminOrderListRoute
  AdminOrderReportsReportIdRoute: typeof AdminOrderReportsReportIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminClientsRoute: AdminClientsRouteWithChildren,
  AdminLkqFuelRateRoute: AdminLkqFuelRateRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminVendorsRoute: AdminVendorsRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminCargoTelConfigsRoute: AdminCargoTelConfigsRoute,
  AdminIntegrationsAppsRoute: AdminIntegrationsAppsRoute,
  AdminIntegrationsCompaniesRoute: AdminIntegrationsCompaniesRoute,
  AdminIntegrationsConfigsRoute: AdminIntegrationsConfigsRoute,
  AdminInvoicesSyncVinAmountsRoute: AdminInvoicesSyncVinAmountsRoute,
  AdminLoadboardsDuplicatesRoute: AdminLoadboardsDuplicatesRoute,
  AdminLoadboardsUnsyncedRoute: AdminLoadboardsUnsyncedRoute,
  AdminOrderCaseLabelsRoute: AdminOrderCaseLabelsRoute,
  AdminOrderListRoute: AdminOrderListRoute,
  AdminOrderReportsReportIdRoute: AdminOrderReportsReportIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface BulkImportImportsRouteChildren {
  BulkImportImportsImportGuidRoute: typeof BulkImportImportsImportGuidRoute
  BulkImportImportsCreateRoute: typeof BulkImportImportsCreateRoute
  BulkImportImportsIndexRoute: typeof BulkImportImportsIndexRoute
}

const BulkImportImportsRouteChildren: BulkImportImportsRouteChildren = {
  BulkImportImportsImportGuidRoute: BulkImportImportsImportGuidRoute,
  BulkImportImportsCreateRoute: BulkImportImportsCreateRoute,
  BulkImportImportsIndexRoute: BulkImportImportsIndexRoute,
}

const BulkImportImportsRouteWithChildren =
  BulkImportImportsRoute._addFileChildren(BulkImportImportsRouteChildren)

interface BulkImportTemplatesRouteChildren {
  BulkImportTemplatesTemplateIdRoute: typeof BulkImportTemplatesTemplateIdRoute
  BulkImportTemplatesCreateRoute: typeof BulkImportTemplatesCreateRoute
  BulkImportTemplatesIndexRoute: typeof BulkImportTemplatesIndexRoute
}

const BulkImportTemplatesRouteChildren: BulkImportTemplatesRouteChildren = {
  BulkImportTemplatesTemplateIdRoute: BulkImportTemplatesTemplateIdRoute,
  BulkImportTemplatesCreateRoute: BulkImportTemplatesCreateRoute,
  BulkImportTemplatesIndexRoute: BulkImportTemplatesIndexRoute,
}

const BulkImportTemplatesRouteWithChildren =
  BulkImportTemplatesRoute._addFileChildren(BulkImportTemplatesRouteChildren)

interface BulkImportRouteChildren {
  BulkImportImportsRoute: typeof BulkImportImportsRouteWithChildren
  BulkImportTemplatesRoute: typeof BulkImportTemplatesRouteWithChildren
  BulkImportIndexRoute: typeof BulkImportIndexRoute
}

const BulkImportRouteChildren: BulkImportRouteChildren = {
  BulkImportImportsRoute: BulkImportImportsRouteWithChildren,
  BulkImportTemplatesRoute: BulkImportTemplatesRouteWithChildren,
  BulkImportIndexRoute: BulkImportIndexRoute,
}

const BulkImportRouteWithChildren = BulkImportRoute._addFileChildren(
  BulkImportRouteChildren,
)

interface TerminalsAssignmentsRouteChildren {
  TerminalsAssignmentsIdRoute: typeof TerminalsAssignmentsIdRoute
  TerminalsAssignmentsCreateRoute: typeof TerminalsAssignmentsCreateRoute
}

const TerminalsAssignmentsRouteChildren: TerminalsAssignmentsRouteChildren = {
  TerminalsAssignmentsIdRoute: TerminalsAssignmentsIdRoute,
  TerminalsAssignmentsCreateRoute: TerminalsAssignmentsCreateRoute,
}

const TerminalsAssignmentsRouteWithChildren =
  TerminalsAssignmentsRoute._addFileChildren(TerminalsAssignmentsRouteChildren)

interface TerminalsLanesRouteChildren {
  TerminalsLanesIdRoute: typeof TerminalsLanesIdRoute
  TerminalsLanesCreateRoute: typeof TerminalsLanesCreateRoute
}

const TerminalsLanesRouteChildren: TerminalsLanesRouteChildren = {
  TerminalsLanesIdRoute: TerminalsLanesIdRoute,
  TerminalsLanesCreateRoute: TerminalsLanesCreateRoute,
}

const TerminalsLanesRouteWithChildren = TerminalsLanesRoute._addFileChildren(
  TerminalsLanesRouteChildren,
)

interface TerminalsLocationsTerminalIdContactsRouteChildren {
  TerminalsLocationsTerminalIdContactsContactIdRoute: typeof TerminalsLocationsTerminalIdContactsContactIdRoute
  TerminalsLocationsTerminalIdContactsCreateRoute: typeof TerminalsLocationsTerminalIdContactsCreateRoute
  TerminalsLocationsTerminalIdContactsContactIdMergeRoute: typeof TerminalsLocationsTerminalIdContactsContactIdMergeRoute
}

const TerminalsLocationsTerminalIdContactsRouteChildren: TerminalsLocationsTerminalIdContactsRouteChildren =
  {
    TerminalsLocationsTerminalIdContactsContactIdRoute:
      TerminalsLocationsTerminalIdContactsContactIdRoute,
    TerminalsLocationsTerminalIdContactsCreateRoute:
      TerminalsLocationsTerminalIdContactsCreateRoute,
    TerminalsLocationsTerminalIdContactsContactIdMergeRoute:
      TerminalsLocationsTerminalIdContactsContactIdMergeRoute,
  }

const TerminalsLocationsTerminalIdContactsRouteWithChildren =
  TerminalsLocationsTerminalIdContactsRoute._addFileChildren(
    TerminalsLocationsTerminalIdContactsRouteChildren,
  )

interface TerminalsLocationsRouteChildren {
  TerminalsLocationsTerminalIdRoute: typeof TerminalsLocationsTerminalIdRoute
  TerminalsLocationsCreateRoute: typeof TerminalsLocationsCreateRoute
  TerminalsLocationsTerminalIdContactsRoute: typeof TerminalsLocationsTerminalIdContactsRouteWithChildren
  TerminalsLocationsTerminalIdMergeRoute: typeof TerminalsLocationsTerminalIdMergeRoute
}

const TerminalsLocationsRouteChildren: TerminalsLocationsRouteChildren = {
  TerminalsLocationsTerminalIdRoute: TerminalsLocationsTerminalIdRoute,
  TerminalsLocationsCreateRoute: TerminalsLocationsCreateRoute,
  TerminalsLocationsTerminalIdContactsRoute:
    TerminalsLocationsTerminalIdContactsRouteWithChildren,
  TerminalsLocationsTerminalIdMergeRoute:
    TerminalsLocationsTerminalIdMergeRoute,
}

const TerminalsLocationsRouteWithChildren =
  TerminalsLocationsRoute._addFileChildren(TerminalsLocationsRouteChildren)

interface TerminalsRouteChildren {
  TerminalsAssignmentsRoute: typeof TerminalsAssignmentsRouteWithChildren
  TerminalsLanesRoute: typeof TerminalsLanesRouteWithChildren
  TerminalsLocationsRoute: typeof TerminalsLocationsRouteWithChildren
  TerminalsIndexRoute: typeof TerminalsIndexRoute
}

const TerminalsRouteChildren: TerminalsRouteChildren = {
  TerminalsAssignmentsRoute: TerminalsAssignmentsRouteWithChildren,
  TerminalsLanesRoute: TerminalsLanesRouteWithChildren,
  TerminalsLocationsRoute: TerminalsLocationsRouteWithChildren,
  TerminalsIndexRoute: TerminalsIndexRoute,
}

const TerminalsRouteWithChildren = TerminalsRoute._addFileChildren(
  TerminalsRouteChildren,
)

interface OrdersOrderGuidRouteChildren {
  OrdersOrderGuidAttachmentsRoute: typeof OrdersOrderGuidAttachmentsRoute
  OrdersOrderGuidLedgerRoute: typeof OrdersOrderGuidLedgerRoute
  OrdersOrderGuidIndexRoute: typeof OrdersOrderGuidIndexRoute
}

const OrdersOrderGuidRouteChildren: OrdersOrderGuidRouteChildren = {
  OrdersOrderGuidAttachmentsRoute: OrdersOrderGuidAttachmentsRoute,
  OrdersOrderGuidLedgerRoute: OrdersOrderGuidLedgerRoute,
  OrdersOrderGuidIndexRoute: OrdersOrderGuidIndexRoute,
}

const OrdersOrderGuidRouteWithChildren = OrdersOrderGuidRoute._addFileChildren(
  OrdersOrderGuidRouteChildren,
)

interface OrdersOrderGuidJobsJobGuidRouteChildren {
  OrdersOrderGuidJobsJobGuidActivityRoute: typeof OrdersOrderGuidJobsJobGuidActivityRoute
  OrdersOrderGuidJobsJobGuidAttachmentsRoute: typeof OrdersOrderGuidJobsJobGuidAttachmentsRoute
  OrdersOrderGuidJobsJobGuidLedgerRoute: typeof OrdersOrderGuidJobsJobGuidLedgerRoute
  OrdersOrderGuidJobsJobGuidRequestsRoute: typeof OrdersOrderGuidJobsJobGuidRequestsRoute
  OrdersOrderGuidJobsJobGuidIndexRoute: typeof OrdersOrderGuidJobsJobGuidIndexRoute
}

const OrdersOrderGuidJobsJobGuidRouteChildren: OrdersOrderGuidJobsJobGuidRouteChildren =
  {
    OrdersOrderGuidJobsJobGuidActivityRoute:
      OrdersOrderGuidJobsJobGuidActivityRoute,
    OrdersOrderGuidJobsJobGuidAttachmentsRoute:
      OrdersOrderGuidJobsJobGuidAttachmentsRoute,
    OrdersOrderGuidJobsJobGuidLedgerRoute:
      OrdersOrderGuidJobsJobGuidLedgerRoute,
    OrdersOrderGuidJobsJobGuidRequestsRoute:
      OrdersOrderGuidJobsJobGuidRequestsRoute,
    OrdersOrderGuidJobsJobGuidIndexRoute: OrdersOrderGuidJobsJobGuidIndexRoute,
  }

const OrdersOrderGuidJobsJobGuidRouteWithChildren =
  OrdersOrderGuidJobsJobGuidRoute._addFileChildren(
    OrdersOrderGuidJobsJobGuidRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountingRoute: AccountingRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  BulkImportRoute: BulkImportRouteWithChildren,
  TerminalsRoute: TerminalsRouteWithChildren,
  JobsStatusRoute: JobsStatusRoute,
  OrderCreateRoute: OrderCreateRoute,
  OrdersOrderGuidRoute: OrdersOrderGuidRouteWithChildren,
  ReportsReportIdRoute: ReportsReportIdRoute,
  OrdersOrderGuidJobsJobGuidRoute: OrdersOrderGuidJobsJobGuidRouteWithChildren,
  OrdersOrderGuidJobsCreateRoute: OrdersOrderGuidJobsCreateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
